module.exports = __webpack_public_path__ + "img/microsoft-edge.96647c15.png";